ch-grid::part(main)::-webkit-scrollbar {
  width: 12px;
  background-color: red;
}

ch-grid::part(main)::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

ch-grid::part(main)::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

ch-grid:focus-within {
  outline: unset;
}

ch-grid-columnset {
  background-color: rgb(212, 212, 212);
}

ch-grid-column {
  padding-block: 4px;
  padding-inline: 4px;
}

ch-grid-column::part(bar) {
  width: 100%;
}

ch-grid-column::part(bar)::after {
  content: "";
  order: 3;
  margin-left: auto;
}

ch-grid-column::part(bar-resize) {
  width: 3px;
}

ch-grid-rowset-legend {
  background-color: lightgrey;
}

ch-grid-row {
  padding-block: 2px;
  border-block-end: 1px solid lightgrey;
}

ch-grid-row[highlighted] {
  background-color: rgb(232, 232, 233);
}

ch-grid-row[selected] {
  background-color: rgb(207, 222, 230);
}

ch-grid-cell {
  padding-inline: 4px;
}

ch-grid-cell[selected] {
  background-color: rgb(207, 222, 230);
  outline: 1px solid rgb(2, 102, 160);
  outline-offset: -1px;
}

ch-grid-cell::part(node-icon) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: center;
}

ch-grid-row:has(> ch-grid-rowset) > ch-grid-cell::part(node-icon) {
  background-image: url("../icons/folder.svg");
}

ch-grid-cell::part(node-icon) {
  background-image: url("../icons/file.svg");
}

ch-grid-rowset-legend::part(icon) {
  width: 16px;
  height: 16px;
  background-image: url("../icons/group.svg");
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: center;
}

ch-grid::part(settings-mask) {
  background-color: rgba(0, 0, 0, 0.2);
}

ch-grid-cell::part(drag-icon) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/drag.svg");
}

ch-grid-cell::part(actions-icon) {
  padding: 0px;
  border: 0px none transparent;
  background-color: transparent;
  box-sizing: content-box;
  font-family: inherit;
  font-size: 100%;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: center;
  background-image: url("../icons/view-more.svg");
}

/* caret */
ch-grid-row > ch-grid-cell::part(caret),
ch-grid-rowset > ch-grid-rowset-legend::part(caret) {
  width: 16px;
  height: 16px;
  background-image: url("../icons/node_collapse.gif");
}

ch-grid-row:is([collapsed], [leaf=false]:not(:has(> ch-grid-rowset))) > ch-grid-cell::part(caret),
ch-grid-rowset[collapsed] > ch-grid-rowset-legend::part(caret) {
  background-image: url("../icons/node_expand.gif");
}

ch-grid-actionbar {
  display: inline-block;
  margin-top: 10px;
}

ch-grid-action-refresh {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  background-position: center;
  background-image: url("../icons/refresh.svg");
}

ch-grid-action-settings {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  background-position: center;
  background-image: url("../icons/settings.svg");
}

ch-grid-column::part(bar-settings-button) {
  all: unset;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/settings.svg");
}

ch-grid-column::part(bar-sort-ascending) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/sort-asc.svg");
}

ch-grid-column::part(bar-sort-descending) {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: center;
  background-image: url("../icons/sort-desc.svg");
}

/* grid settings window */
ch-grid::part(settings-window),
ch-grid-column::part(settings-window) {
  background: white;
  padding: 5px;
  border: solid 1px grey;
}

ch-grid::part(settings-header),
ch-grid-column::part(settings-header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

ch-grid::part(settings-caption),
ch-grid-column::part(settings-caption) {
  text-transform: uppercase;
}

ch-grid::part(settings-close),
ch-grid-column::part(settings-close) {
  background-position: center;
  margin-bottom: 0px;
  cursor: pointer;
}

/* indentation */
ch-grid {
  --indent: 16px;
}

.column-settings {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 100px;
}

ch-grid-row-actions[show-on-row-hover]::part(window) {
  margin-right: 19px;
}

*,
::after,
::before {
  box-sizing: border-box;
}

ch-test-flexible-layout {
  display: contents;
}
ch-test-flexible-layout .welcome-message {
  margin-block-start: var(--spacing--l, var(--mer-spacing--md));
  text-align: center;
  font-size: 64px;
  line-height: 80px;
  opacity: 0.75;
}

ch-action-group-render {
  padding-inline: var(--mer-spacing--sm, 12px);
}
ch-action-group-render::part(separator) {
  background-color: currentColor;
  margin-block: var(--mer-spacing--2xs, var(--spacing--xs));
}

.flexible-layout::part(leaf inline) {
  background-color: var(--mer-surface__elevation--01);
}
.flexible-layout::part(tab-list block) {
  overflow: auto;
}